<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
            <v-card class="elevation-12 cardBgColor" >
                <v-toolbar dark  color="secondary" dense>
                    <v-toolbar-title >修改維護密碼</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-form>
                        <br>
                        <v-text-field  :rules="[value => !!value || '請輸入使用者代號']"
                                       prepend-icon="mdi-account" ref="userId" v-model="userId" name="login"
                                       label="使用者代號" type="text" @keyup.enter="NextItem('oldPass')" ></v-text-field>

                        <v-text-field ref="oldPass" id="oldPass" prepend-icon="mdi-lock" v-model="oldPass" name="oldPass" label="舊密碼"
                                      @keyup.enter="NextItem('newPass')"
                                      :append-icon="showOld ? 'mdi-eye-off' : 'mdi-eye'"
                                      :type="showOld ? 'text' : 'password'"
                                      @click:append="showOld = !showOld"
                                      :rules="[value => !!value || '請輸入舊密碼']"
                        ></v-text-field>
                        <v-text-field ref="newPass" id="newPass" prepend-icon="mdi-lock" v-model="newPass" name="newPass" label="新密碼"
                                      @keyup.enter="NextItem('newPass2')"
                                      :append-icon="showNew ? 'mdi-eye-off' : 'mdi-eye'"
                                      :type="showNew ? 'text' : 'password'"
                                      @click:append="showNew = !showNew"
                                      :rules="[value => !!value || '請輸入新密碼']"></v-text-field>
                        <v-text-field ref="newPass2" id="newPass2" prepend-icon="mdi-lock" v-model="newPass2" name="newPass2" label="確認新密碼"
                                      @keyup.enter="confirmPass"
                                      :append-icon="showNew2 ? 'mdi-eye-off' : 'mdi-eye'"
                                      :type="showNew2 ? 'text' : 'password'"
                                      @click:append="showNew2 = !showNew2"
                                      :rules="[value => !!value || '請輸入確認新密碼']"></v-text-field>

                    </v-form>
                </v-card-text>
                <v-card-actions style="padding: 1rem">
                    <v-spacer class="loginFont">請輸入維護者密碼 !!</v-spacer>
                    <v-btn class="loginFont"  @click="confirmPass" >確定</v-btn>
                </v-card-actions>
                <v-progress-linear :indeterminate="processStatus"></v-progress-linear>
            </v-card>

            <v-alert :value="showMessage" :type="typeMsg">
                <span v-html="message"></span>
                <!--{{message}}-->
            </v-alert>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "ModiMaintainPass",
        data() {
            return {
                userId:'',
                oldPass: '',
                showOld:false,
                newPass: '',
                showNew:false,
                newPass2:'',
                showNew2:false,
                processStatus:false,
                showMessage:false,
                typeMsg:'error',
                message:'',
                maintainObj:{},
                mainPassList:[],
            }
        },
        created(){
          this.axios_getMaintainPass();
        },
        methods:{
            findMaintainUserId(userId){
                return this.mainPassList.filter((i) => {
                    return (i.value1==userId); //確認使用者是否在設定檔中
                })
            },
            confirmPass(){
                let userPass = this.findMaintainUserId(this.userId);
                if(this.userId!==''&&this.userId!==null&&this.oldPass!==''&&this.oldPass!==null){ //先驗證是否輸入正確的使用者帳密
                    if(userPass.length>0&&this.oldPass!==userPass[0].value2){
                        this.showMessage = true;
                        this.message = "舊密碼輸入錯誤"
                        this.typeMsg = 'error';
                        this.$refs.oldPass.focus();
                        return;
                    }else if(userPass.length==0) {
                        this.showMessage = true;
                        this.message = "使用者不存在"
                        this.typeMsg = 'error';
                        this.$refs.userId.focus();
                        return;
                    }
                }

                if(this.newPass!==''&&this.newPass!==null&&this.newPass2!==''&&this.newPass2!==null){
                        if(this.newPass==this.newPass2){
                            this.maintainObj = userPass[0];
                            this.maintainObj.value2 = this.newPass;
                           this.axios_putSysSet(this.maintainObj)
                        }else {
                            this.showMessage = true;
                            this.message = "新密碼需與確認新密碼相同"
                            this.typeMsg = 'error';
                        }
                }

                if(this.userId==''||this.userId==null||this.oldPass==''||this.oldPass==null||this.newPass==''||this.newPass==null||this.newPass2==''||this.newPass2==null){
                    this.showMessage = true;
                    this.message = "請確認是否輸入完整"
                    this.typeMsg = 'error';
                    return;
                }


            },
            NextItem:function(id) {
                this.$refs[id].focus();
            },
            //https://172.16.1.71:20443/iRegaSrv/rest/iregsetting/datasearch/bygroupidcode/BASEINFO/MAINTAIN_PASS
            axios_getMaintainPass (){ //查詢維護程式密碼
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/BASEINFO/MAINTAIN_PASS";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.mainPassList = response.data.resultSet;
                    }else {
                        this.mainPassList = [];
                    }

                }).catch(error =>  {
                    this.mainPassList = [];
                    try {
                        console.log(error.response.data.status);
                    } catch(err) {
                        console.log(err.response.data.status);
                    }
                });
            },
            axios_putSysSet(putData){ //修改 資料來源
                let postList = [];
                postList.push(putData);
                let url = this.$store.state.AppSetting.backSrvUrl+'iregsetting/';

                this.$http.put(url,postList).then(response=>{
                    if(response.data.resultSet.length>0){
                        this.typeMsg='success';
                        this.showMessage = true;
                        this.message = response.data.message;
                        this.axios_getMaintainPass();
                    }


                }).catch(error =>{
                    try{
                        this.showMessage = true;
                        this.typeMsg='error';
                        this.message = error.response.data.message;


                    }catch (e) {
                        this.showMessage = true;
                        this.typeMsg='error';
                        this.message = error.response.data.message;
                    }
                });
            },
        }
    }
</script>

<style scoped>

</style>